import { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line,
         CartesianGrid, Legend, RadarChart, Radar, PolarGrid, PolarAngleAxis,
         PolarRadiusAxis, Cell, PieChart, Pie } from "recharts";

// ── PALETA ──────────────────────────────────────────────────────────────────
const BG    = "#0A0E1A";
const CARD  = "#111827";
const BORD  = "#1e2d47";
const TEXT  = "#F1F5F9";
const MUTED = "#64748b";
const GOLD  = "#D4AF37";

// ── DATOS DE COMPAÑÍAS ──────────────────────────────────────────────────────
const COMPANIES = {
  "OCASO": {
    color: "#0057A8", short: "OCA",
    deals2026: 147, prima: 1373.96, franquicia: 0,   capital: 2311586, m2: 2866, viviendas: 21.7, año: 1994, primTotal: 201972,
    cotizaciones: 1236, conversion: 11.9,
    total2024: 965, total2025: 1201,
    hist: {
      "2024": [90,113,73,103,89,80,91,80,83,105,83,78],
      "2025": [103,100,116,88,95,109,99,71,114,142,117,109],
    },
  },
  "REALE": {
    color: "#E8380D", short: "REA",
    deals2026: 95, prima: 1042.29, franquicia: 178, capital: 1498985, m2: 1797, viviendas: 14.0, año: 1978, primTotal: 99017,
    cotizaciones: 1349, conversion: 7.0,
    total2024: 560, total2025: 583,
    hist: {
      "2024": [40,41,37,61,40,43,34,46,54,47,35,39],
      "2025": [33,48,34,29,38,36,27,28,47,63,55,45],
    },
  },
  "MAPFRE": {
    color: "#004990", short: "MAP",
    deals2026: 83, prima: 1454.74, franquicia: 4,   capital: 1487901, m2: 1726, viviendas: 14.6, año: 1979, primTotal: 120743,
    cotizaciones: 1258, conversion: 6.6,
    total2024: 386, total2025: 553,
    hist: {
      "2024": [33,31,26,24,28,29,33,27,30,50,42,33],
      "2025": [55,53,45,43,46,34,31,24,47,67,50,58],
    },
  },
  "ALLIANZ": {
    color: "#0ea5e9", short: "ALZ",
    deals2026: 46, prima: 1320.16, franquicia: 54,  capital: 1709861, m2: 2077, viviendas: 18.1, año: 1972, primTotal: 60727,
    cotizaciones: 1305, conversion: 3.5,
    total2024: 148, total2025: 311,
    hist: {
      "2024": [11,15,12,7,12,7,19,13,16,16,8,12],
      "2025": [22,25,28,22,18,25,34,18,34,33,28,23],
    },
  },
  "SANTA LUCÍA": {
    color: "#C8102E", short: "SL",
    deals2026: 45, prima: 1777.10, franquicia: 91,  capital: 3421589, m2: 4306, viviendas: 29.2, año: 1985, primTotal: 79970,
    cotizaciones: 1437, conversion: 3.1,
    total2024: 257, total2025: 368,
    hist: {
      "2024": [28,21,18,23,30,29,12,9,17,25,23,22],
      "2025": [36,32,35,37,24,38,21,14,29,35,26,41],
    },
  },
  "GENERALI ON": {
    color: "#6366f1", short: "GON",
    deals2026: 41, prima: 1403.67, franquicia: 13,  capital: 2451577, m2: 3290, viviendas: 18.5, año: 2004, primTotal: 57550,
    cotizaciones: 678, conversion: 6.0,
    total2024: 127, total2025: 224,
    hist: {
      "2024": [2,2,11,7,8,12,12,10,14,30,25,24],
      "2025": [21,28,12,11,22,29,13,16,20,15,15,22],
    },
  },
  "OCCIDENT": {
    color: "#10b981", short: "OCC",
    deals2026: 41, prima: 2168.29, franquicia: 7,   capital: 3218624, m2: 3978, viviendas: 35.2, año: 1986, primTotal: 88900,
    cotizaciones: 961, conversion: 4.3,
    total2024: 89,  total2025: 97,
    hist: {
      "2024": [7,3,5,12,12,18,10,10,5,4,1,2],
      "2025": [2,0,1,2,3,1,1,9,19,24,16,19],
    },
  },
  "GENERALI": {
    color: "#8b5cf6", short: "GEN",
    deals2026: 17, prima: 1196.66, franquicia: 0,   capital: 1530021, m2: 1897, viviendas: 13.5, año: 1973, primTotal: 20343,
    cotizaciones: 458, conversion: 3.7,
    total2024: 181, total2025: 149,
    hist: {
      "2024": [9,21,26,18,15,16,9,17,16,14,14,6],
      "2025": [19,17,10,13,10,10,21,6,11,10,6,16],
    },
  },
  "MUTUA PROP.": {
    color: "#f59e0b", short: "MUT",
    deals2026: 16, prima: 2135.28, franquicia: 19,  capital: 3249732, m2: 3556, viviendas: 23.6, año: 1972, primTotal: 34164,
    cotizaciones: 676, conversion: 2.4,
    total2024: 50,  total2025: 133,
    hist: {
      "2024": [0,4,4,2,4,1,2,5,4,10,6,8],
      "2025": [9,9,19,14,12,23,16,9,10,11,11,10],
    },
  },
  "CASER": {
    color: "#ec4899", short: "CAS",
    deals2026: 15, prima: 1902.49, franquicia: 147, capital: 2481440, m2: 3543, viviendas: 26.5, año: 1987, primTotal: 28537,
    cotizaciones: 1433, conversion: 1.0,
    total2024: 71,  total2025: 71,
    hist: {
      "2024": [4,7,3,6,11,9,7,1,6,4,9,4],
      "2025": [6,5,12,8,12,5,5,3,5,5,5,5],
    },
  },
};

const MESES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
const COMPANY_NAMES = Object.keys(COMPANIES);
const TOTAL_MARKET_2026 = Object.values(COMPANIES).reduce((s,c) => s + c.deals2026, 0) + 6; // +otros

const marketBarData = COMPANY_NAMES.map(n => ({ company: n === "MUTUA DE PROPIETARIOS" ? "MUTUA PROP." : n, deals: COMPANIES[n].deals2026, color: COMPANIES[n].color }));

// ── HELPERS ─────────────────────────────────────────────────────────────────
const fmt    = (n, d=0) => n?.toLocaleString("es-ES",{minimumFractionDigits:d,maximumFractionDigits:d});
const fmtEur = (n, d=0) => "€"+fmt(n,d);

const CustomTT = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{background:"#1e293b",border:`1px solid ${BORD}`,borderRadius:8,padding:"10px 14px"}}>
      <div style={{color:MUTED,fontSize:11,marginBottom:6}}>{label}</div>
      {payload.map((p,i)=>(
        <div key={i} style={{color:p.color||TEXT,fontSize:13,fontWeight:600}}>
          {p.name}: {fmt(p.value)}
        </div>
      ))}
    </div>
  );
};

function StatCard({label, value, sub, color}) {
  return (
    <div style={{
      background: color ? `linear-gradient(135deg,${color}18 0%,${color}08 100%)` : CARD,
      border:`1px solid ${color ? color+"33" : BORD}`,
      borderRadius:12,padding:"18px 20px",display:"flex",flexDirection:"column",gap:5,
    }}>
      <div style={{color:MUTED,fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.12em"}}>{label}</div>
      <div style={{color:color||TEXT,fontSize:26,fontWeight:700,lineHeight:1}}>{value}</div>
      {sub && <div style={{color:MUTED,fontSize:11}}>{sub}</div>}
    </div>
  );
}

function Section({title, children}) {
  return (
    <div style={{marginBottom:36}}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
        <div style={{width:4,height:22,background:"#C8102E",borderRadius:2}}/>
        <h2 style={{margin:0,color:TEXT,fontSize:14,fontWeight:700,letterSpacing:"0.06em",textTransform:"uppercase"}}>{title}</h2>
      </div>
      {children}
    </div>
  );
}

// ── COMPONENTE PRINCIPAL ─────────────────────────────────────────────────────
export default function InformeCompanias() {
  const [selected, setSelected] = useState("SANTA LUCÍA");
  const [tab, setTab] = useState("resumen");
  const co = COMPANIES[selected];
  const share = (co.deals2026 / TOTAL_MARKET_2026 * 100).toFixed(1);
  const rank  = [...COMPANY_NAMES].sort((a,b)=>COMPANIES[b].deals2026-COMPANIES[a].deals2026).indexOf(selected)+1;

  // Histórico para el gráfico
  const histChartData = MESES.map((m,i) => ({
    mes: m,
    "2024": co.hist["2024"][i] || 0,
    "2025": co.hist["2025"][i] || 0,
  }));

  // Tabla mercado
  const tableData = [...COMPANY_NAMES]
    .sort((a,b) => COMPANIES[b].deals2026 - COMPANIES[a].deals2026)
    .map(n => ({ ...COMPANIES[n], name: n, isSelected: n === selected }));

  // Radar
  const maxPrima = Math.max(...COMPANY_NAMES.map(n => COMPANIES[n].prima));
  const maxCapital = Math.max(...COMPANY_NAMES.map(n => COMPANIES[n].capital));
  const maxM2 = Math.max(...COMPANY_NAMES.map(n => COMPANIES[n].m2));
  const maxViv = Math.max(...COMPANY_NAMES.map(n => COMPANIES[n].viviendas));
  const maxConv = Math.max(...COMPANY_NAMES.map(n => COMPANIES[n].conversion));
  const avgPrima = COMPANY_NAMES.reduce((s,n) => s+COMPANIES[n].prima,0)/COMPANY_NAMES.length;
  const avgCapital = COMPANY_NAMES.reduce((s,n) => s+COMPANIES[n].capital,0)/COMPANY_NAMES.length;
  const avgM2 = COMPANY_NAMES.reduce((s,n) => s+COMPANIES[n].m2,0)/COMPANY_NAMES.length;
  const avgViv = COMPANY_NAMES.reduce((s,n) => s+COMPANIES[n].viviendas,0)/COMPANY_NAMES.length;
  const avgConv = COMPANY_NAMES.reduce((s,n) => s+COMPANIES[n].conversion,0)/COMPANY_NAMES.length;

  const radarData = [
    { subject:"Prima",      co: Math.round(co.prima/maxPrima*100),      avg: Math.round(avgPrima/maxPrima*100) },
    { subject:"Capital",    co: Math.round(co.capital/maxCapital*100),   avg: Math.round(avgCapital/maxCapital*100) },
    { subject:"m²",         co: Math.round(co.m2/maxM2*100),            avg: Math.round(avgM2/maxM2*100) },
    { subject:"Viviendas",  co: Math.round(co.viviendas/maxViv*100),    avg: Math.round(avgViv/maxViv*100) },
    { subject:"Conversión", co: Math.round(co.conversion/maxConv*100),  avg: Math.round(avgConv/maxConv*100) },
    { subject:"Cuota",      co: Math.round(co.deals2026/TOTAL_MARKET_2026*100*4), avg:50 },
  ];

  const tabs = [
    {id:"resumen",    label:"Resumen"},
    {id:"mercado",    label:"Mercado"},
    {id:"perfil",     label:"Perfil Riesgo"},
    {id:"conversion", label:"Conversión"},
    {id:"proyeccion", label:"Proyección"},
  ];

  return (
    <div style={{background:BG,minHeight:"100vh",fontFamily:"'Georgia','Times New Roman',serif",color:TEXT,paddingBottom:60}}>

      {/* ── HEADER FIJO ── */}
      <div style={{background:"linear-gradient(135deg,#080b14 0%,#0d1020 100%)",borderBottom:`1px solid ${BORD}`,padding:"20px 32px 0",position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div>
            <div style={{color:MUTED,fontSize:10,fontWeight:600,letterSpacing:"0.2em",textTransform:"uppercase"}}>
              MULTIRRIESGO COMUNIDADES · ENE–FEB 2026
            </div>
            <div style={{color:TEXT,fontSize:20,fontWeight:700,marginTop:2}}>
              Análisis por Compañía Aseguradora
            </div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{color:MUTED,fontSize:10,marginBottom:2}}>COMPAÑÍA SELECCIONADA</div>
            <div style={{color:co.color,fontSize:18,fontWeight:700}}>{selected}</div>
            <div style={{color:MUTED,fontSize:11}}>{rank}ª posición · {co.deals2026} deals · {share}% cuota</div>
          </div>
        </div>

        {/* Botonera compañías */}
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:0,paddingBottom:0}}>
          {COMPANY_NAMES.map(name => {
            const c = COMPANIES[name];
            const isActive = name === selected;
            return (
              <button key={name} onClick={() => { setSelected(name); setTab("resumen"); }} style={{
                background: isActive ? c.color : "transparent",
                border: `1px solid ${isActive ? c.color : BORD}`,
                color: isActive ? "#fff" : MUTED,
                borderRadius:"6px 6px 0 0",
                padding:"7px 12px",
                fontSize:11,fontWeight:700,
                letterSpacing:"0.04em",
                cursor:"pointer",
                transition:"all 0.15s",
                fontFamily:"inherit",
                borderBottom: isActive ? `1px solid ${c.color}` : `1px solid ${BORD}`,
              }}>
                {c.short} <span style={{fontSize:10,opacity:0.8}}>{c.deals2026}</span>
              </button>
            );
          })}
        </div>

        {/* Tabs */}
        <div style={{display:"flex",borderTop:`1px solid ${BORD}`,marginTop:-1}}>
          {tabs.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              background:"none",border:"none",
              color: tab===t.id ? co.color : MUTED,
              fontFamily:"inherit",fontSize:11,fontWeight:600,
              letterSpacing:"0.05em",textTransform:"uppercase",
              padding:"12px 16px",cursor:"pointer",
              borderBottom: tab===t.id ? `2px solid ${co.color}` : "2px solid transparent",
              transition:"all 0.2s",
            }}>{t.label}</button>
          ))}
        </div>
      </div>

      <div style={{padding:"28px 32px"}}>

        {/* ═══ RESUMEN ═══ */}
        {tab==="resumen" && (
          <div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:14}}>
              <StatCard label="Deals Ganados 2026"   value={co.deals2026}              sub={`${rank}ª posición de ${COMPANY_NAMES.length}`}    color={co.color}/>
              <StatCard label="Prima Media"           value={fmtEur(co.prima)}          sub="Prima neta sin franquicia"/>
              <StatCard label="Capital Continente"    value={fmtEur(co.capital/1e6,2)+"M"} sub="Valor medio asegurado"/>
              <StatCard label="Prima Total Generada"  value={fmtEur(co.primTotal)}      sub="Ene–Feb 2026"/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:28}}>
              <StatCard label="Cotizaciones Emitidas" value={fmt(co.cotizaciones)}      sub={`#${[...COMPANY_NAMES].sort((a,b)=>COMPANIES[b].cotizaciones-COMPANIES[a].cotizaciones).indexOf(selected)+1} en volumen`}/>
              <StatCard label="Tasa Conversión"       value={co.conversion+"%"}         sub="Cotiz. → deal ganado"/>
              <StatCard label="m² Medios Comunidad"   value={fmt(co.m2)+" m²"}          sub="Tamaño del riesgo"/>
              <StatCard label="Franquicia Media"       value={co.franquicia===0?"Sin franquicia":fmtEur(co.franquicia)} sub="Coste al cliente en siniestro"/>
            </div>

            {/* Comparativa rápida con el mercado */}
            <div style={{background:"#0d1520",border:`1px solid #1e3a5f`,borderRadius:12,padding:22,marginBottom:20}}>
              <div style={{color:GOLD,fontSize:12,fontWeight:700,letterSpacing:"0.1em",marginBottom:16,textTransform:"uppercase"}}>
                📊 Posición vs Media del Mercado
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12}}>
                {[
                  { label:"Prima media", val:fmtEur(co.prima), avg:fmtEur(Math.round(avgPrima)), better: co.prima>avgPrima },
                  { label:"Capital cont.", val:fmtEur(co.capital/1e6,2)+"M", avg:fmtEur(Math.round(avgCapital/1e6),1)+"M", better: co.capital>avgCapital },
                  { label:"m² medios", val:fmt(co.m2)+" m²", avg:fmt(Math.round(avgM2))+" m²", better: co.m2>avgM2 },
                  { label:"Viviendas", val:co.viviendas, avg:avgViv.toFixed(1), better: co.viviendas>avgViv },
                  { label:"Conversión", val:co.conversion+"%", avg:avgConv.toFixed(1)+"%", better: co.conversion>avgConv },
                ].map((item,i) => (
                  <div key={i} style={{background:CARD,borderRadius:8,padding:"14px 12px",textAlign:"center"}}>
                    <div style={{color:MUTED,fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>{item.label}</div>
                    <div style={{color:co.color,fontSize:17,fontWeight:700}}>{item.val}</div>
                    <div style={{color:MUTED,fontSize:10,margin:"4px 0"}}>Mercado: {item.avg}</div>
                    <div style={{fontSize:10,fontWeight:700,color:item.better?"#10b981":"#f59e0b"}}>
                      {item.better ? "▲ SOBRE MEDIA" : "▼ BAJO MEDIA"}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Histórico rápido */}
            <Section title="Tendencia Mensual 2024 vs 2025">
              <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                <div style={{display:"flex",gap:24,marginBottom:8}}>
                  {[
                    {label:"Total 2024", val:co.total2024},
                    {label:"Total 2025", val:co.total2025},
                    {label:"Variación", val:(((co.total2025-co.total2024)/co.total2024)*100).toFixed(1)+"%", color:co.total2025>co.total2024?"#10b981":"#f87171"},
                  ].map((s,i) => (
                    <div key={i}>
                      <div style={{color:MUTED,fontSize:10,textTransform:"uppercase",fontWeight:600}}>{s.label}</div>
                      <div style={{color:s.color||TEXT,fontSize:20,fontWeight:700}}>{s.val}</div>
                    </div>
                  ))}
                </div>
                <ResponsiveContainer width="100%" height={220}>
                  <LineChart data={histChartData} margin={{top:5,right:20,left:0,bottom:0}}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#1e2d47"/>
                    <XAxis dataKey="mes" tick={{fill:MUTED,fontSize:11}}/>
                    <YAxis tick={{fill:MUTED,fontSize:11}}/>
                    <Tooltip content={<CustomTT/>}/>
                    <Legend wrapperStyle={{color:MUTED,fontSize:12}}/>
                    <Line type="monotone" dataKey="2024" stroke="#60a5fa" strokeWidth={2} dot={{fill:"#60a5fa",r:3}} name="2024"/>
                    <Line type="monotone" dataKey="2025" stroke={co.color} strokeWidth={2.5} dot={{fill:co.color,r:4}} name="2025"/>
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Section>
          </div>
        )}

        {/* ═══ MERCADO ═══ */}
        {tab==="mercado" && (
          <div>
            <Section title="Ranking de Deals Ganados – Ene–Feb 2026">
              <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={tableData} margin={{top:10,right:20,left:0,bottom:0}}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#1e2d47"/>
                    <XAxis dataKey="name" tick={{fill:MUTED,fontSize:10}}/>
                    <YAxis tick={{fill:MUTED,fontSize:11}}/>
                    <Tooltip content={<CustomTT/>}/>
                    <Bar dataKey="deals2026" name="Deals ganados" radius={[4,4,0,0]}>
                      {tableData.map((entry,i) => (
                        <Cell key={i} fill={entry.color} opacity={entry.isSelected?1:0.45}/>
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Section>

            <div style={{display:"grid",gridTemplateColumns:"3fr 2fr",gap:20}}>
              <Section title="Tabla Completa del Mercado">
                <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead>
                      <tr>{["#","Compañía","Deals","Cuota","Prima Media","Franquicia","Capital"].map(h=>(
                        <th key={h} style={{color:MUTED,textAlign:"right",padding:"6px 8px",borderBottom:`1px solid ${BORD}`,fontWeight:600,fontSize:10,textTransform:"uppercase"}}>{h}</th>
                      ))}</tr>
                    </thead>
                    <tbody>
                      {tableData.map((d,i)=>(
                        <tr key={i} style={{background:d.isSelected?`${d.color}12`:"transparent",cursor:"pointer"}} onClick={()=>setSelected(d.name)}>
                          <td style={{padding:"8px",color:MUTED,fontSize:11}}>{i+1}</td>
                          <td style={{padding:"8px",color:d.isSelected?d.color:TEXT,fontWeight:d.isSelected?700:400}}>
                            {d.isSelected?"▶ ":""}{d.name}
                          </td>
                          <td style={{padding:"8px",textAlign:"right",color:TEXT,fontWeight:d.isSelected?700:400}}>{d.deals2026}</td>
                          <td style={{padding:"8px",textAlign:"right",color:MUTED}}>{(d.deals2026/TOTAL_MARKET_2026*100).toFixed(1)}%</td>
                          <td style={{padding:"8px",textAlign:"right",color:TEXT}}>{fmtEur(d.prima)}</td>
                          <td style={{padding:"8px",textAlign:"right",color:d.franquicia>50?"#f59e0b":MUTED}}>{d.franquicia===0?"—":fmtEur(d.franquicia)}</td>
                          <td style={{padding:"8px",textAlign:"right",color:TEXT}}>{fmtEur(d.capital/1e6,2)}M</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div style={{color:MUTED,fontSize:10,marginTop:8}}>💡 Haz clic en cualquier fila para cambiar de compañía</div>
                </div>
              </Section>

              <Section title="Cuota de Mercado">
                <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie data={tableData} dataKey="deals2026" nameKey="name" cx="50%" cy="50%" outerRadius={110} innerRadius={50}
                        label={({name,deals2026})=>`${deals2026}`}>
                        {tableData.map((entry,i)=>(
                          <Cell key={i} fill={entry.color} opacity={entry.isSelected?1:0.45} strokeWidth={entry.isSelected?2:0} stroke={entry.isSelected?entry.color:"none"}/>
                        ))}
                      </Pie>
                      <Tooltip formatter={(v,n)=>[v+" deals",n]}/>
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </Section>
            </div>
          </div>
        )}

        {/* ═══ PERFIL RIESGO ═══ */}
        {tab==="perfil" && (
          <div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginBottom:28}}>
              <Section title="Radar vs Media del Mercado">
                <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                  <ResponsiveContainer width="100%" height={300}>
                    <RadarChart data={radarData}>
                      <PolarGrid stroke={BORD}/>
                      <PolarAngleAxis dataKey="subject" tick={{fill:MUTED,fontSize:12}}/>
                      <PolarRadiusAxis tick={{fill:MUTED,fontSize:9}} domain={[0,100]}/>
                      <Radar name={selected} dataKey="co" stroke={co.color} fill={co.color} fillOpacity={0.3} strokeWidth={2}/>
                      <Radar name="Media mercado" dataKey="avg" stroke="#60a5fa" fill="#60a5fa" fillOpacity={0.1} strokeWidth={1.5} strokeDasharray="4 4"/>
                      <Legend wrapperStyle={{color:MUTED,fontSize:11}}/>
                    </RadarChart>
                  </ResponsiveContainer>
                </div>
              </Section>

              <Section title="Indicadores del Riesgo Asegurado">
                <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`,height:"100%",boxSizing:"border-box"}}>
                  {[
                    {icon:"🏗️", label:"Año construcción medio",  val:co.año,                        avg:1981 },
                    {icon:"📐", label:"m² construidos medios",    val:fmt(co.m2)+" m²",              avg:fmt(Math.round(avgM2))+" m²" },
                    {icon:"🏘️", label:"Viviendas por comunidad",  val:co.viviendas,                  avg:avgViv.toFixed(1) },
                    {icon:"🛡️", label:"Capital continente medio", val:fmtEur(co.capital/1e6,2)+"M", avg:fmtEur(Math.round(avgCapital/1e6),1)+"M" },
                    {icon:"⚡", label:"Franquicia media",          val:co.franquicia===0?"Sin franquicia":fmtEur(co.franquicia), avg:"€53" },
                  ].map((row,i)=>(
                    <div key={i} style={{display:"flex",alignItems:"center",justifyContent:"space-between",
                      padding:"12px 0",borderBottom:i<4?`1px solid ${BORD}`:"none"}}>
                      <div style={{display:"flex",alignItems:"center",gap:10}}>
                        <span style={{fontSize:18}}>{row.icon}</span>
                        <span style={{color:MUTED,fontSize:12}}>{row.label}</span>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{color:co.color,fontWeight:700,fontSize:15}}>{row.val}</div>
                        <div style={{color:MUTED,fontSize:10}}>Mercado: {row.avg}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </Section>
            </div>

            <Section title="m² Medios por Compañía">
              <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                <ResponsiveContainer width="100%" height={240}>
                  <BarChart data={tableData} margin={{top:5,right:20,left:0,bottom:0}}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#1e2d47"/>
                    <XAxis dataKey="name" tick={{fill:MUTED,fontSize:10}}/>
                    <YAxis tick={{fill:MUTED,fontSize:10}}/>
                    <Tooltip content={<CustomTT/>}/>
                    <Bar dataKey="m2" name="m² medios" radius={[4,4,0,0]}>
                      {tableData.map((entry,i)=>(
                        <Cell key={i} fill={entry.isSelected?entry.color:"#334155"} opacity={entry.isSelected?1:0.7}/>
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Section>
          </div>
        )}

        {/* ═══ CONVERSIÓN ═══ */}
        {tab==="conversion" && (
          <div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:28}}>
              <StatCard label="Cotizaciones emitidas" value={fmt(co.cotizaciones)} sub="Sobre todas las deals cerradas" color={co.color}/>
              <StatCard label="Tasa de conversión"    value={co.conversion+"%"}   sub="Cotizaciones → deals ganados"/>
              <StatCard label="Potencial adicional"   value={"~"+Math.round(co.cotizaciones*0.119-co.deals2026)} sub="Deals si igualara conversión OCASO (11,9%)"/>
            </div>

            <Section title="Cotizaciones vs Deals Ganados – Todas las Compañías">
              <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart
                    data={[...COMPANY_NAMES].sort((a,b)=>COMPANIES[b].cotizaciones-COMPANIES[a].cotizaciones)
                      .map(n=>({name:n,cotizaciones:COMPANIES[n].cotizaciones,ganados:COMPANIES[n].deals2026,conversion:COMPANIES[n].conversion,isSelected:n===selected,color:COMPANIES[n].color}))}
                    margin={{top:10,right:20,left:0,bottom:0}}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#1e2d47"/>
                    <XAxis dataKey="name" tick={{fill:MUTED,fontSize:10}}/>
                    <YAxis yAxisId="left"  tick={{fill:MUTED,fontSize:11}}/>
                    <YAxis yAxisId="right" orientation="right" tick={{fill:MUTED,fontSize:10}} unit="%" domain={[0,14]}/>
                    <Tooltip content={<CustomTT/>}/>
                    <Legend wrapperStyle={{color:MUTED,fontSize:12}}/>
                    <Bar yAxisId="left" dataKey="cotizaciones" name="Cotizaciones" fill="#334155" radius={[4,4,0,0]}/>
                    <Bar yAxisId="left" dataKey="ganados" name="Deals ganados" radius={[4,4,0,0]}>
                      {[...COMPANY_NAMES].sort((a,b)=>COMPANIES[b].cotizaciones-COMPANIES[a].cotizaciones)
                        .map((n,i)=>(<Cell key={i} fill={COMPANIES[n].color} opacity={n===selected?1:0.5}/>))}
                    </Bar>
                    <Line yAxisId="right" type="monotone" dataKey="conversion" name="Conversión %" stroke={GOLD} strokeWidth={2} dot={{fill:GOLD,r:3}}/>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Section>

            <Section title="Ranking de Conversión">
              <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                {[...COMPANY_NAMES].sort((a,b)=>COMPANIES[b].conversion-COMPANIES[a].conversion).map((name,i)=>{
                  const c = COMPANIES[name];
                  const isSel = name===selected;
                  const barW = (c.conversion/maxConv*100).toFixed(0);
                  return (
                    <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 0",
                      borderBottom:`1px solid ${BORD}`,cursor:"pointer",background:isSel?`${c.color}10`:"transparent",
                      borderRadius:isSel?6:0,paddingLeft:isSel?8:0}}
                      onClick={()=>setSelected(name)}>
                      <div style={{width:20,color:MUTED,fontSize:12,textAlign:"center"}}>{i+1}</div>
                      <div style={{width:120,color:isSel?c.color:TEXT,fontSize:12,fontWeight:isSel?700:400}}>{name}</div>
                      <div style={{flex:1,height:8,background:`${BORD}`,borderRadius:4,overflow:"hidden"}}>
                        <div style={{width:barW+"%",height:"100%",background:isSel?c.color:"#334155",borderRadius:4,transition:"width 0.3s"}}/>
                      </div>
                      <div style={{width:50,textAlign:"right",color:isSel?c.color:TEXT,fontWeight:700,fontSize:13}}>{c.conversion}%</div>
                      <div style={{width:80,textAlign:"right",color:MUTED,fontSize:11}}>{c.ganados||c.deals2026} / {fmt(c.cotizaciones)}</div>
                    </div>
                  );
                })}
              </div>
            </Section>
          </div>
        )}

        {/* ═══ PROYECCIÓN ═══ */}
        {tab==="proyeccion" && (
          <div>
            <Section title={`Histórico Mensual – ${selected}`}>
              <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                <div style={{display:"flex",gap:28,marginBottom:12}}>
                  {[
                    {label:"Total 2024", val:co.total2024, color:"#60a5fa"},
                    {label:"Total 2025", val:co.total2025, color:co.color},
                    {label:"Var. anual",  val:(((co.total2025-co.total2024)/co.total2024)*100).toFixed(1)+"%", color:co.total2025>co.total2024?"#10b981":"#f87171"},
                    {label:"Proyec. cons. 2026", val:"~"+Math.round(co.total2025*1.12), color:GOLD},
                  ].map((s,i)=>(
                    <div key={i}>
                      <div style={{color:MUTED,fontSize:10,textTransform:"uppercase",fontWeight:600,letterSpacing:"0.08em"}}>{s.label}</div>
                      <div style={{color:s.color,fontSize:22,fontWeight:700}}>{s.val}</div>
                    </div>
                  ))}
                </div>
                <ResponsiveContainer width="100%" height={260}>
                  <LineChart data={histChartData} margin={{top:5,right:20,left:0,bottom:0}}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#1e2d47"/>
                    <XAxis dataKey="mes" tick={{fill:MUTED,fontSize:11}}/>
                    <YAxis tick={{fill:MUTED,fontSize:11}}/>
                    <Tooltip content={<CustomTT/>}/>
                    <Legend wrapperStyle={{color:MUTED,fontSize:12}}/>
                    <Line type="monotone" dataKey="2024" stroke="#60a5fa" strokeWidth={2} dot={{fill:"#60a5fa",r:3}} name="2024"/>
                    <Line type="monotone" dataKey="2025" stroke={co.color} strokeWidth={2.5} dot={{fill:co.color,r:4}} name="2025"/>
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Section>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
              <Section title="Escenarios de Proyección 2026">
                <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                  {[
                    {label:"Base 2025",            val:co.total2025,                      color:co.color},
                    {label:"Conservador (+12%)",   val:Math.round(co.total2025*1.12),     color:GOLD},
                    {label:"Moderado (+20%)",      val:Math.round(co.total2025*1.20),     color:"#10b981"},
                    {label:"Optimista (+30%)",     val:Math.round(co.total2025*1.30),     color:"#4ade80"},
                    {label:"Prima anual estimada (cons.)", val:fmtEur(Math.round(co.total2025*1.12*co.prima)), color:GOLD},
                  ].map((row,i)=>(
                    <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
                      padding:"12px 0",borderBottom:i<4?`1px solid ${BORD}`:"none"}}>
                      <span style={{color:MUTED,fontSize:12}}>{row.label}</span>
                      <span style={{color:row.color,fontWeight:700,fontSize:16}}>{row.val}</span>
                    </div>
                  ))}
                </div>
              </Section>

              <Section title="Comparativa Evolución Todas las Compañías (2024→2025)">
                <div style={{background:CARD,borderRadius:12,padding:22,border:`1px solid ${BORD}`}}>
                  {[...COMPANY_NAMES].sort((a,b)=>{
                    const vA = (COMPANIES[a].total2025-COMPANIES[a].total2024)/COMPANIES[a].total2024;
                    const vB = (COMPANIES[b].total2025-COMPANIES[b].total2024)/COMPANIES[b].total2024;
                    return vB-vA;
                  }).map((name,i)=>{
                    const c = COMPANIES[name];
                    const pct = ((c.total2025-c.total2024)/c.total2024*100).toFixed(1);
                    const positive = c.total2025 >= c.total2024;
                    const isSel = name===selected;
                    return (
                      <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 0",
                        borderBottom:`1px solid ${BORD}`,cursor:"pointer",background:isSel?`${c.color}10`:"transparent",
                        borderRadius:isSel?4:0,paddingLeft:isSel?8:0}}
                        onClick={()=>setSelected(name)}>
                        <div style={{width:100,color:isSel?c.color:TEXT,fontSize:11,fontWeight:isSel?700:400}}>{name}</div>
                        <div style={{color:MUTED,fontSize:10,width:60,textAlign:"right"}}>{c.total2024}</div>
                        <div style={{color:MUTED,fontSize:10,width:20,textAlign:"center"}}>→</div>
                        <div style={{color:TEXT,fontSize:10,width:60}}>{c.total2025}</div>
                        <div style={{flex:1,textAlign:"right",color:positive?"#10b981":"#f87171",fontWeight:700,fontSize:12}}>
                          {positive?"+":""}{pct}%
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Section>
            </div>
          </div>
        )}

      </div>

      <div style={{textAlign:"center",color:MUTED,fontSize:10,padding:"16px 32px 0",borderTop:`1px solid ${BORD}`,marginTop:20}}>
        Brokalia · brokalia_core · Criterio: winner asignado + sin motivo de pérdida · 18/02/2026 · Solo uso interno
      </div>
    </div>
  );
}
